




























import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import { readEntryByLabel } from "@/store/uniabc/getters";
import Entry from "@/interfaces/uniabc/Entry";
import Renderer from "@/utils/Renderer";
import { getLang, Language } from "@/interfaces/uniabc/Language";
import { api } from "@/api";
import { readGitLabInfo } from "@/store/gitlab/getters";
import { dispatchRaiseErrorTimeout } from "@/store/appState/actions";

@Component({
  components: {}
})
export default class RenderEntry extends Vue {
  @Prop(String) readonly label!: string;
  @Prop(String) readonly langStr!: string;
  @PropSync("recomputeRefs", { type: Number }) updateRefs!: number;
  private entry: Entry = readEntryByLabel(this.$store)(this.label || "");
  private image = "";
  private imgSet = false;

  private footnoteHeaders = [
    { text: "ID", value: "identifier" },
    { text: "Text", value: "text" }
  ];

  @Watch("entry.image_url")
  onChangeImage(newVal: string) {
    if (newVal === "") {
      this.imgSet = false;
    } else {
      this.getImage();
    }
  }

  private async getImage() {
    const gitLab = readGitLabInfo(this.$store);
    try {
      this.image = await api.getImageBase64(
        gitLab.projectId,
        gitLab.branch,
        this.entry.image_url
      );
      this.imgSet = true;
    } catch (e) {
      dispatchRaiseErrorTimeout(
        this.$store,
        new Error(`Unable to load Image:<br>${e}`)
      );
    }
  }

  private async mounted() {
    if (this.entry.image_url) {
      await this.getImage();
    }
  }

  get lang() {
    return getLang(this.langStr);
  }

  get term() {
    return this.lang === Language.DE ? this.entry.term_de : this.entry.term_en;
  }

  get altTerm() {
    return this.lang === Language.DE
      ? this.entry.alt_term_de
      : this.entry.alt_term_en;
  }

  get renderedText() {
    this.updateRefs;
    return Renderer.renderedText(this.entry, this.lang);
  }

  get renderedFootnote() {
    this.updateRefs;
    return Renderer.renderedFootnotes(this.entry, this.lang);
  }

  get img() {
    return this.image;
  }
}
